import Api from "../../../services/Api";
import { sanitizeSerialPathParam } from "../../../lib/utils/apiValidation";

/**
 * SECURITY FIX H-6: Added input validation to prevent injection attacks
 * SECURITY WARNING: Server MUST validate user owns this serialNumber (IDOR risk)
 *
 * @param {string} serialNumber - Charger serial number
 * @param {string} startDate - ISO format date
 * @param {string} endDate - ISO format date
 * @param {number} page - Page number
 * @param {number} pageSize - Page size
 * @param {object} filters - Additional filters
 */
function fetchOcppMessages(serialNumber, startDate, endDate, page, pageSize = 10000, filters) {
  // Validate serial number
  const safeSerial = sanitizeSerialPathParam(serialNumber);

  // Validate dates (ISO format: YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss)
  const datePattern = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?)?$/;
  if (!datePattern.test(startDate) || !datePattern.test(endDate)) {
    throw new Error("Invalid date format: must be ISO format");
  }

  // Validate pagination
  const safePage = Number(page);
  const safePageSize = Number(pageSize);
  if (!Number.isInteger(safePage) || safePage < 0) {
    throw new Error("Invalid page number");
  }
  if (!Number.isInteger(safePageSize) || safePageSize < 1 || safePageSize > 100000) {
    throw new Error("Invalid page size: must be 1-100000");
  }
  const params = {
    start: startDate,
    end: endDate,
    page: safePage,
    pageSize: safePageSize,
    ...filters,
  };

  return Api.get(`/service/iqevse-csms/charger/v1/ocpp-messages/${safeSerial}`, params, {
    paramsSerializer: {
      serialize: params => {
        const query = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach(v => query.append(key, v));
          } else {
            query.append(key, value);
          }
        });

        return query.toString();
      },
    },
  });
}

export { fetchOcppMessages };
